import React, { Component } from 'react';
import { StripeProvider } from 'react-stripe-elements';

import { bugsnagError } from 'services/bugsnag';
import warehouse from 'services/warehouse';

export default class StripeProviderHOC extends Component {
  state = {
    // This is our Stripe API token.
    // We currently get this from our BE.
    stripeToken: null,

    // This flag tracks whether or not the stripe JS script
    // has been successfully loaded
    stripeJSLoaded: false
  }

  componentDidMount () {
    this.loadStripeJS();
    this.fetchStripeAPIToken();
  }

  componentDidUpdate () {
    // When both the stripe token and the stripe script have been loaded,
    // we can set the Stripe instance which will be used by the Provider.
    const { stripeJSLoaded, stripeToken } = this.state;
    const { onSetStripeInstance, stripeInstance } = this.props;
    if (
      !stripeInstance &&
      stripeToken &&
      stripeJSLoaded &&
      window.Stripe
    ) {
      const instance = window.Stripe(stripeToken);
      onSetStripeInstance(instance);
    }
  }

  loadStripeJS = () => {
    let script = document.createElement('script');
    script.onload = () => {
      if (!window.Stripe) {
        bugsnagError(new Error(`Stripe V3 loaded but window.Stripe is ${window.Stripe}`));
        return;
      }

      // SUCCESS!
      this.setState({ stripeJSLoaded: true });
    };
    script.src = 'https://js.stripe.com/v3/';

    // This kicks off an async download of the script
    document.head.appendChild(script);
  }

  fetchStripeAPIToken = async (attempt = 1) => {
    try {
      const stripeToken = await warehouse.fetchStripeApiToken();
      this.setState({ stripeToken });
    } catch (error) {
      // This is a bad error so leaving in this error log.
      console.error(`fetching stripe API token failed with: ${JSON.stringify(error.message)}`);
      bugsnagError(error);

      // This is BAD, checkout will not work.
      // Wait a few seconds and try again.
      // If we are out of attempts, there are no good
      // options at this point so we will allow the
      // user to continue with a degraded experience.
      const MAX_ATTEMPTS = 3;
      if (attempt < MAX_ATTEMPTS) {
        window.setTimeout(() => {
          this.fetchStripeAPIToken(attempt + 1);
        }, 3000);
      }
    }
  }

  render () {
    return (
      <StripeProvider stripe={this.props.stripeInstance}>
        {this.props.children}
      </StripeProvider>
    );
  }
}
